const styles = (theme) => ({
  dataGrid: {
    minHeight: 150,
    height: 180,
    maxHeight: 240,
    border: `1px solid ${theme.AppBGColor}`,
    "& .ag-theme-material .ag-body-horizontal-scroll": {
      borderWidth: "0px",
    },
    "&>.gridTheme-light>.ag-theme-material.theme-light, &>.gridTheme-dark>.ag-theme-material.theme-dark":
      {
        height: "100%",
      },
    "& .statusBar": {
      display: "none",
    },
  },
  gridContent: {
    borderColor: theme.AppBGColor,
    borderStyle: "solid",
    borderWidth: "1px",
    boxSizing: "border-box",
    height: "100%",
    minHeight: "100%",
    maxHeight: "100%",
    "& .ag-center-cols-viewport": {
      width: `calc(100% + 18px)`,
    },
    "& .statusBar": {
      display: "block",
    },
  },
});

export default styles;
